module.exports = __webpack_public_path__ + "img/PREOCUPADOS.91c6c230.png";